<template>
  <span></span>
</template>

<script>
export default {
  name: "dataLayer-event",
  props: {
    eventName: {
      type: String
    },
    fbEvent: {
      type: String
    }
  },
  mounted() {
    console.log("dataLayer event...", this.eventName);
    if (window.dataLayer && this.eventName) {
      // eslint-disable-next-line
      dataLayer.push({
        event_action: this.eventName
      });
    }
    if (window.fbq && this.fbEvent) {
      // eslint-disable-next-line
      fbq("track", this.fbEvent);
    }
  }
};
</script>
